import api from './api';

const state = {
	user: null,
	status: '',
	token: null,
	error: false,
	success: false,
	message: '',
	resetToken: false,
};

const getters = {
	token: state => {
		return state.token;
	},
	isLoggedIn: state => {
		return !!state.token;
	},
};

const mutations = {
	auth_success(state, { user }) {
		state.user = user;
		state.status = 'success';
		state.error = false;
	},
	set_token(state, { token }) {
		state.token = token;
	},
	resetToken(state) {
		state.resetToken = true;
		state.error = false;
	},
	noResetToken(state) {
		state.resetToken = false;
	},
	auth_error(state, { message }) {
		state.status = 'error';
		state.error = true;
		state.message = message;
	},
	auth_removeErrorMessage(state) {
		state.error = false;
		state.message = '';
	},
	auth_removeSuccessMessage(state) {
		state.success = false;
		state.message = '';
	},
	auth_successRequest(state, { message }) {
		state.success = true;
		state.error = false;
		state.message = message;
	},
	auth_successReset(state, { message }) {
		state.success = true;
		state.error = false;
		state.message = message;
	},
	logout(state) {
		state.status = '';
		state.token = null;
		state.user = {};
	},
	getToken(state) {
		state.token = localStorage.getItem('token');
	},
};

const actions = {
	login({ state, commit, rootGetters, dispatch }, { username, password }) {
		return api
			.login(username, password)
			.then(async response => {
				const token = response.data.token;
				localStorage.setItem('token', token);
				commit('set_token', { token });
				await dispatch('load');
			})
			.catch(err => {
				const message = err.response.data.error.message;
				commit('auth_error', { message });
			});
	},
	logout({ commit }) {
		commit('logout');
		localStorage.removeItem('token');
		console.log('Successfully logged out!');
	},
	getToken({ commit }) {
		if (localStorage.getItem('token')) {
			commit('getToken');
		}
	},
	requestPasswordReset({ state, commit, rootGetters, dipatch }, email) {
		return api
			.requestPasswordReset(email)
			.then(response => {
				const message = response.data.message;
				commit('auth_successRequest', { message });
			})
			.catch(err => {
				const message = err.response.data.message;
				commit('auth_error', { message });
			});
	},
	validateToken({ state, commit, rootGetters, dipatch }, token) {
		return api
			.verifyToken(token)
			.then(response => {
				if (response.status == 200) {
					commit('resetToken');
				}
			})
			.catch(err => {
				commit('noResetToken');
			});
	},
	resetPassword({ state, commit, rootGetters, dipatch }, { password, token }) {
		return api
			.resetPassword(password, token)
			.then(res => {
				const message = res.data.message;
				commit('auth_successReset', { message });
			})
			.catch(err => {
				const message = err.response.data.message;
				commit('auth_error', { message });
			});
	},
	changePassword({ state, commit, rootGetters, dipatch }, { password }) {
		return api
			.changePassword(password)
			.then(res => {
				const message = res.data.message;
				commit('auth_successReset', { message });
			})
			.catch(err => {
				const message = err.response.data.message;
				commit('auth_error', { message });
			});
	},
	load({ state, commit, dispatch, rootGetters }) {
		return api
			.load()
			.then(response => {
				const user = response.data;
				const token = localStorage.getItem(token);
				commit('auth_success', { user });
			})
			.catch(err => {
				//Check if a token existed
				if (state.token != null) {
					const message = err.response.data.message;
					commit('auth_error', { message });
				}
				dispatch('logout');
			});
	},
	removeError({ state, commit, rootGetters }) {
		commit('auth_removeErrorMessage');
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
